import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=4535e062&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=4535e062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535e062",
  null
  
)

export default component.exports